import { DialogLike } from "@obg/mat.ui.core";

import { MultiDepositLimitMessageComponent } from "./multi-deposit-limit-message.component";

export const MULTI_DEPOSIT_LIMIT_MESSAGE_DIALOG: DialogLike<MultiDepositLimitMessageComponent> = {
	dialogId: "multi-deposit-limit-message-dialog",
	dialogComponentType: MultiDepositLimitMessageComponent,
};
